<template>
  <div class="gyff-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="报价日期">
              <el-date-picker
                v-model="searchForm.time"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                :clearable="false"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="车间">
              <el-select v-model="searchForm.factory" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option v-for="item in factoryList" v-if="item.brand===0||group.dBrand===0||group.dBrand===item.brand" :key="item.factory_id" :label="item.simple_name" :value="item.factory_id" />
              </el-select>
            </el-form-item> -->
            <el-form-item label="组织">
              <el-select v-model="searchForm.group" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option v-for="item in groupList" :key="item.groupid" :label="item.group_name" :value="item.groupid" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="getData">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row :gutter="20">
              <el-col :span="16" style="padding-top: 20px">
                <el-table
                  :data="tableData"
                  v-loading="loading"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    prop="name"
                    label="工艺"
                    align="center"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="priceTotal"
                    align="center"
                    label="金额">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="金额占比">
                    <template slot-scope="scope">
                      <span>{{ scope.row.scaleTotal }}%</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="详情">
                    <template slot-scope="scope">
                      <el-button icon="el-icon-search" @click="view(scope.row)" size="mini">查看详情</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="8">
                <GraphicsChart id="circle" :option="circleOption"/>
              </el-col>
              <el-col :span="24" style="padding-top: 40px">
                <GraphicsChart id="height" :option="columnOption"/>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="viewTitle"
      :visible.sync="viewVisible"
      width="80%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <div style="padding:10px 20px">
        <div style="height:40px">
          <span style="color:#99a9bf">工艺：</span>
          <span style="font-weight: 500">{{ viewName }}</span>
          <span style="color:#99a9bf;margin-left: 20px">报价日期：</span>
          <span style="">{{ viewTime }}</span>
          <span style="color:#99a9bf;margin-left: 20px">金额：</span>
          <span style="color:#409EFF;font-weight: 500;">{{ viewAmount }}</span>
          <el-button icon="el-icon-printer" style="float: right" size="small" :loading="excelLoading" @click="exportExcel">导出Excel</el-button>
        </div>
        <el-table
          :data="viewData"
          v-loading="viewLoading"
          size="small"
          style="width: 100%;border:1px solid #EBEEF5;"
          height="442">
          <el-table-column
            prop="ordernum"
            label="订单号"
            align="center"
            width="120"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            label="生产单号"
            width="90"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="font-weight: 500;color:#409EFF" v-if="scope.row.produnum!==null&&scope.row.produnum!==''&&scope.row.produnum!==undefined">{{scope.row.produnum}}</span>
              <span style="font-weight: 500;color:#999999" v-if="scope.row.produnum===null||scope.row.produnum===''||scope.row.produnum===undefined">N/A</span>
            </template>
          </el-table-column>
          <el-table-column
            label="经销商"
            width="120"
            align="center"
            prop="delname"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            label="订单类型"
            align="center"
            width="110"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.type===0">正单</span>
              <span v-if="scope.row.type===1">客改单</span>
              <span v-if="scope.row.type===2">增补单</span>
              <span v-if="scope.row.type===3">色板单</span>
              <span v-if="scope.row.type===4">售后单</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="详细地址"
            min-width="200"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            label="报价时间"
            width="160"
            align="center"
            prop="time"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            label="金额"
            width="120"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="font-weight: 500;color:#409EFF">{{scope.row.amount}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="viewPage.total>0"
          style="margin-top:10px;"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="viewPage.currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="viewPage.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="viewPage.total">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getFactoryList,
  getOfferCraftsAnalysis,
  getOfferAnalysisOrderList,
  exportOfferAnalysisOrderListExcel,
  getGroupInfoByUser
} from '@/api/erp'
import GraphicsChart from '../../../components/Charts/GraphicsChart'
import { getGroupReport } from '@/api/pub'

export default {
  name: 'bjgyfx',
  components: { GraphicsChart },
  computed: {
    user: getUser
  },
  data() {
    return {
      tableData: [],
      loading: false,
      searchForm: {
        search: '',
        time: [],
        factory: '',
        group: null
      },
      groupList: [],
      factoryList: [],
      columnData: [],
      columnOption: {
        title: false,
        exporting: {
          enabled: true
        },
        credits: {
          enabled: false
        }
      },
      circleOption: {
        title: false,
        exporting: {
          enabled: true
        },
        credits: {
          enabled: false
        }
      },
      viewTitle: '',
      viewVisible: false,
      viewAmount: 0,
      viewTime: '',
      viewName: '',
      excelLoading: false,
      viewData: [],
      viewLoading: [],
      viewPage: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      group: {
        dBrand: 1
      }
    }
  },
  created() {
    getGroupInfoByUser({ groupid: this.user.dGroupid }).then(response => {
      this.group = response.data
    })
    this.searchForm.group = this.user.dGroupid
    // this.getFactoryList()
    this.getGroupList()
    const myDate = new Date()
    const year = myDate.getFullYear()
    let month = myDate.getMonth() + 1
    let day = myDate.getDate()
    month = month > 9 ? month + '' : '0' + month
    day = day > 9 ? day + '' : '0' + day
    this.searchForm.time.push(year + '-' + month + '-01')
    this.searchForm.time.push(year + '-' + month + '-' + day)
    this.getData()
  },
  methods: {
    getData() {
      let startTime = ''
      let endTime = ''
      if (this.searchForm.time !== null && this.searchForm.time.length === 2){
        startTime = this.searchForm.time[0]
        endTime = this.searchForm.time[1]
      }
      const data = {
        factory: this.searchForm.factory,
        group: this.searchForm.group,
        keyword: this.searchForm.search,
        startTime: startTime,
        endTime: endTime,
        type: 0,
        userid: this.user.dUserid
      }
      this.loading = true
      this.columnData = []
      getOfferCraftsAnalysis(data).then(response => {
        let circleData = []
        for (const item of response.data.craftsTable) {
          this.columnData.push({
            name: item.name,
            data: [item.priceTotal]
          })
          circleData.push({
            name: item.name,
            y: item.scaleTotal
          })
        }
        let chart = {
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          chart: {
            type: 'column'
          },
          title: false,
          credits: {
            enabled: false
          },
          xAxis: {
            categories: [
              '工艺'
            ],
            crosshair: true
          },
          yAxis: {
            min: 0,
            title: false
          },
          tooltip: {
            // head + 每个 point + footer 拼接成完整的 table
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
              '<td style="padding:0"><b>{point.y:.1f} 元</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          },
          plotOptions: {
            column: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.y}'
              }
            }
          },
          series: this.columnData
        }
        this.columnOption = chart
        let circle = {
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
          },
          title: false,
          credits: {
            enabled: false
          },
          tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.percentage:.1f} %'
              }
            }
          },
          series: [{
            name: '占比',
            colorByPoint: true,
            data: circleData
          }]
        }
        this.circleOption = circle
        this.tableData = response.data.craftsTable
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // getFactoryList() {
    //   getFactoryList().then(response => {
    //     this.factoryList = response.data
    //   })
    // },
    getGroupList() {
      getGroupReport().then(response => {
        const arr = []
        for (const item of response.data) {
          if (item.nature === 0) {
            arr.push(item)
          }
        }
        this.groupList = arr
      })
    },
    view(row) {
      this.viewTitle = row.name + '报价详情'
      this.viewName = row.name
      if (this.searchForm.time.length === 2) {
        this.viewTime = this.searchForm.time[0] + ' 至 ' + this.searchForm.time[1]
      } else {
        this.viewTime = 'N/A'
      }
      this.viewAmount = row.priceTotal
      this.viewVisible = true
      this.viewPage.currentPage = 1
      this.viewPage.pageSize = 10
      this.getDetailData()
    },
    getDetailData() {
      this.viewLoading = true
      let startTime = ''
      let endTime = ''
      if (this.searchForm.time !== null && this.searchForm.time.length === 2){
        startTime = this.searchForm.time[0]
        endTime = this.searchForm.time[1]
      }
      let type = 99
      if (this.viewName === '贴皮') {
        type = 1
      } else if (this.viewName === '混油') {
        type = 2
      } else if (this.viewName === '免漆板') {
        type = 3
      } else if (this.viewName === '其他') {
        type = 4
      }
      const data = {
        factory: this.searchForm.factory,
        startTime: startTime,
        endTime: endTime,
        type: type,
        page: this.viewPage.currentPage,
        limit: this.viewPage.pageSize,
        group: this.searchForm.group,
        userid: this.user.dUserid
      }
      getOfferAnalysisOrderList(data).then(response => {
        this.viewData = response.data
        this.viewPage.total = response.total
        this.viewLoading = false
      }).catch(() => {
        this.viewLoading = false
      })
    },
    handleSizeChange(val) {
      this.viewPage.pageSize = val
      this.getDetailData()
    },
    handleCurrentChange(val) {
      this.viewPage.currentPage = val
      this.getDetailData()
    },
    exportExcel() {
      if (!this.excelLoading) {
        this.excelLoading = true
        let startTime = ''
        let endTime = ''
        if (this.searchForm.time !== null && this.searchForm.time.length === 2){
          startTime = this.searchForm.time[0]
          endTime = this.searchForm.time[1]
        }
        let type = 99
        if (this.viewName === '贴皮') {
          type = 1
        } else if (this.viewName === '混油') {
          type = 2
        } else if (this.viewName === '免漆板') {
          type = 3
        } else if (this.viewName === '其他') {
          type = 4
        }
        const data = {
          factory: this.searchForm.factory,
          group: this.searchForm.group,
          startTime: startTime,
          endTime: endTime,
          type: type,
          name: this.viewName,
          userid: this.user.dUserid
        }
        this.$message({
          message: '数据正在导出，请稍候'
        })
        exportOfferAnalysisOrderListExcel(data).then(response => {
          const _this = this
          let xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              let blob = this.response
              let a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                        href: window.URL.createObjectURL(blob),
                        target: '_blank',
                        download: `${response.data.dName}.${response.data.dType}`,
                        style: 'color: #409EFF;text-decoration:underline;'
                      }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
          this.excelLoading = false
        }).catch(() => {
          this.excelLoading = false
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
